// src/components/Footer.js

import React from 'react';
import './Footer.css';
import { FaLinkedin, FaGithub, FaInstagram } from 'react-icons/fa'; // Import icons

import footerPhoto from '../assets/codex-logo.jpg';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-logo-section footer-section">
        <img src={footerPhoto} alt="Logo" />
        <p>Where education meets real-world needs.</p>
      </div>
      <div className="footer-links-section footer-section">
        <h4>Helpful Links</h4>
        <ul className="footer-links">
          <li><a href="#courses">Courses</a></li>
          <li><a href="#privacy-policy">Privacy Policy</a></li>
          <li><a href="#refund-policy">Refund Policy</a></li>
          <li><a href="#terms-conditions">Terms & Conditions</a></li>
        </ul>
      </div>
      <div className="footer-contact-section footer-section">
        <h4 id='footer'>Contact Us</h4>
        <ul className="footer-links">
          <li><a href="mailto:alpha@codexcrew.com">alpha@codexcrew.com</a></li>
          <li><a href="mailto:beta@codexcrew.com">beta@codexcrew.com</a></li>
          <li><a href="mailto:gamma@codexcrew.com">gamma@codexcrew.com</a></li>
          <li>Support Team: 10am - 6pm</li>
        </ul>
      </div>
      <div className="footer-socials-section footer-section">
        <h4>Connect with Us</h4>
        <div className="footer-socials">
          <a href="" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
          <a href="https://github.com/Codex-Crew-IGIT" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
          <a href="https://www.instagram.com/codexcrew.igit/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2024 Codex Crew. All rights reserved.</p>
        <p>Made with 💻 & <span>💙</span> by Codex Crew</p>
      </div>
    </footer>
  );
}

export default Footer;
